export type NavCurrency = "BRL" | "USD";

export const NAV_CURRENCIES: readonly NavCurrency[] = ["BRL", "USD"];

export const DEFAULT_NAV_CURRENCY: NavCurrency = "USD";

export const isNavCurrency = (value: unknown): value is NavCurrency =>
  typeof value === "string" && (NAV_CURRENCIES as readonly string[]).includes(value);
